import { CapoPlugin } from "D:/www/aparecidanp/aparecidanp.com.br/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];